import {getButtonsProps, getColorProps, getNumberProps, getSliderProps} from ".";
import ColorField from "../ColorField";
import NumberField from "../NumberField";
import SelectField from "../SelectField";
import SliderField from "../SliderField";
import PropertyLabel from "./PropertyLabel";
import SectorRow from "./SectorRow";

export default function SectorTypography({sector}) {
    return (
        <>
            <SectorRow>
                <PropertyLabel property={sector.getProperty('font-family')}>
                    <SelectField {...getButtonsProps(sector.getProperty('font-family'))}/>
                </PropertyLabel>
            </SectorRow>
            <SectorRow>
                <PropertyLabel property={sector.getProperty('color')}>
                    <ColorField {...getColorProps(sector.getProperty('color'))}/>
                </PropertyLabel>
            </SectorRow>
            <SectorRow>
                <PropertyLabel property={sector.getProperty('font-size')}>
                    <NumberField {...getNumberProps(sector.getProperty('font-size'))}/>
                </PropertyLabel>
                <PropertyLabel property={sector.getProperty('font-weight')}>
                    <SelectField {...getButtonsProps(sector.getProperty('font-weight'))}/>
                </PropertyLabel>
            </SectorRow>
            <SectorRow>
                <PropertyLabel property={sector.getProperty('letter-spacing')}>
                    <SliderField {...getSliderProps(sector.getProperty('letter-spacing'))}></SliderField>
                    <NumberField {...getNumberProps(sector.getProperty('letter-spacing'))}></NumberField>
                </PropertyLabel>
            </SectorRow>
            <SectorRow>
                <PropertyLabel property={sector.getProperty('line-height')}>
                    <SliderField {...getSliderProps(sector.getProperty('line-height'))}></SliderField>
                    <NumberField {...getNumberProps(sector.getProperty('line-height'))}></NumberField>
                </PropertyLabel>
            </SectorRow>
            <SectorRow>
                <PropertyLabel property={sector.getProperty('text-align')}>
                    <SelectField {...getButtonsProps(sector.getProperty('text-align'))}/>
                </PropertyLabel>
                <PropertyLabel property={sector.getProperty('text-decoration')}>
                    <SelectField {...getButtonsProps(sector.getProperty('text-decoration'))}/>
                </PropertyLabel>
            </SectorRow>
        </>
    );
}